App.directive('setMinHeightContent', ['$window', function($window) {
    return {
        link: link,
        restrict: 'A'
    };

    function link(scope, elem, attrs) {
        function onResize() {
            var clientHeight = window.innerHeight;
            var topBarHeight = $('.top-bar .top').height();
            elem[0].style['min-height'] = clientHeight - topBarHeight + 'px';
        }

        angular.element(document).ready(function() {
            onResize();
        });

        angular.element($window).on('resize', function() {
            onResize();
        });
    };
}]);